/**
 * 计算指定时间到现在是多少岁, 注意是向下取整. 0.5岁为0岁, 20.1岁为20岁;
 * @param birthday 生日时间, 能转换成Date对象的数字, 字符串或者Date对象;
 * @example	{{1420041600000|age}} => 4
 */
export default function (birthday: any): number{
	function toDate (argument: any): Date{
		if (arguments.length < 1) {
			throw new Error('参数个数不正确, 请传递至少一个日期值!');
		}
		const argStr: string = Object.prototype.toString.call(argument);
		if (argument instanceof Date || (typeof argument === 'object' && argStr === '[object Date]')) {
			return new Date(argument.getTime());
		} else if (typeof argument === 'number' || argStr === '[object Number]') {
			return new Date(argument);
		} else if (typeof argument === 'string' || argStr === '[object String]') {
			try {
				return new Date(argument);
			} catch (e) {
				console.error('时间字符串类型转换失败, 使用当前时间初始化!');
			}
		}
		return new Date();
	}
	function compareAsc (dirtyDateLeft: any, dirtyDateRight: any): number{
		if (arguments.length < 2) {
			throw new TypeError('参数个数不正确, 请传递两个日期参数作对比!');
		}

		const dateLeft: Date = toDate(dirtyDateLeft);
		const dateRight: Date = toDate(dirtyDateRight);
		const diff = dateLeft.getTime() - dateRight.getTime();

		if (diff < 0) {
			return -1;
		} else if (diff > 0) {
			return 1;
		} else {
			return diff;
		}
	}
	function differenceInCalendarYears (dirtyDateLeft: any, dirtyDateRight: any): number{
		if (arguments.length < 2) {
			throw new TypeError('参数个数不正确, 请传递两个日期参数作对比!');
		}

		const dateLeft: Date = toDate(dirtyDateLeft);
		const dateRight: Date = toDate(dirtyDateRight);

		return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	function differenceInYears (dirtyDateLeft: any, dirtyDateRight: any): number{
		if (arguments.length < 2) {
			throw new Error('参数个数不正确, 请传递两个日期参数作对比!');
		}

		const dateLeft: Date = toDate(dirtyDateLeft);
		const dateRight: Date = toDate(dirtyDateRight);

		const sign: number = compareAsc(dateLeft, dateRight);
		const difference: number = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
		dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference);

		const isLastYearNotFull: any = compareAsc(dateLeft, dateRight) === -sign;
		const result: number = sign * (difference - isLastYearNotFull);
		return result === 0 ? 0 : result;
	}
	return differenceInYears(Date.now(), birthday);
}
